import React, {useEffect, useState} from 'react';
import "./header.css"
import logo from "../../res/img/logo.png";
import phone from "../../res/img/phone.png";
import {useHistory, useParams} from "react-router-dom";
import Sidebar from "../sidebar/sidebar";
import {useSelector} from "react-redux";
import Api from "../../services/api";
import {toast} from "react-toastify";
import {devices} from "../../utils/devices";

const Header = () => {
    let device = devices();
    let param = useParams()
    const setting = useSelector(state => state.setting.setting)
    const history = useHistory()
    const [sidebar, setSidebar] = useState(false)
    const [searchData, setSearchData] = useState("")
    const [delay, setDelay] = useState(null)
    const [searchText, setSearchText] = useState("")
    const [toggleSearch, searchToggleSearch] = useState(false)
    const search = async (text) => {
        clearTimeout(delay)
        setSearchText(text)
        if (text === "") {
            searchToggleSearch(false)
            return false
        }
        setDelay(setTimeout(() => {
            new Api().post("/search", {q: text})
                .then((res) => {
                    setSearchData(res)
                    searchToggleSearch(true)
                }).catch(() => {
                toast.error("نتیجه ای یافت نشد")
            })
        }, 500))

    }
    useEffect(()=>{
        setSidebar(false)
    } , [param] )
    return (
        <div className={"header"}>
            <div className={"container"}>
                <div className={"header-center-section"}>
                    <div className={"header-center-section-ok"}>
                        <div onClick={() => {
                            history.push('/')
                        }} className={"logo"}>
                            <div className={"logo-section"}>
                                <img src={logo}/>
                            </div>
                            <h1>{setting && setting.title}</h1>
                        </div>
                        <div className={"phone"}>
                            <div onClick={() => {window.location.assign(device === 'desktop'? `https://web.whatsapp.com/send?phone=31641012277` : "https://api.whatsapp.com/send?phone=31641012277")}}>
                                <img src="https://img.icons8.com/color/48/000000/whatsapp--v6.png"/>
                                <span>  تماس  ( واتساپ )  : </span>
                                <span>{"641012277 - ( 0031 )"}</span>
                            </div>
                        </div>
                        <div className={"header-down-section"}>
                            <div onClick={() => {
                                setSidebar(true)
                            }} className={"sidebar-icon"}>
                                <img src="https://img.icons8.com/ios-filled/50/000000/menu-rounded.png"/>
                                <span>
                                    دسته بندی
                                </span>
                            </div>
                            <Sidebar onchange={(e) => {
                                setSidebar(e)
                            }} show={sidebar}/>
                            <div className={"search"}>
                                <input onFocus={() =>  search(searchText)} onBlur={() => {searchToggleSearch(false)}} placeholder={"جستجو در سایت"} value={searchText}
                                       onChange={(e) => search(e.target.value)}/>
                            </div>
                        </div>
                        {
                            <div
                                className={`search-result-box ${searchData && toggleSearch ? "show-search" : "hide-search"}`}>
                                {
                                    searchData && searchData.status ?
                                        <>
                                            {
                                                searchData && searchData.result && searchData.result.blog.length > 0 &&
                                                <div className={"search-item"}>
                                                        <div className={"search-result-box-title"}> نتایج مربوط به وبلاگ :</div>
                                                        {
                                                            searchData && searchData.result && searchData.result.blog.map((item) => {
                                                                return (
                                                                    <div onClick={() => {
                                                                        history.push(`/blog/${item._id}`, {props: item});
                                                                        searchToggleSearch(false)
                                                                    }} className={"search-item-result"}>
                                                                        <span>{item.title}</span>
                                                                        <div dangerouslySetInnerHTML={{__html:item.description.substr(0,200)}}/>
                                                                    </div>
                                                                )
                                                            })
                                                        }
                                                </div>
                                            }
                                            {
                                                searchData && searchData.result && searchData.result.gallery.length > 0 &&
                                                <div className={"search-item"}>
                                                    <div className={"search-result-box-title"}> نتایج مربوط به گالری تصاویر :</div>
                                                    {
                                                        searchData && searchData.result && searchData.result.gallery.map((item) => {
                                                            return (
                                                                <div onClick={() => {
                                                                    history.push(`/gallery`, {props: item});
                                                                    searchToggleSearch(false)
                                                                }} className={"search-item-result"}>
                                                                    <span>{item.title}</span>
                                                                    <div dangerouslySetInnerHTML={{__html:item.description.substr(0,200)}}/>
                                                                </div>
                                                            )
                                                        })
                                                    }
                                                </div>
                                            }
                                            {
                                                searchData && searchData.result && searchData.result.introduction.length > 0 &&
                                                <div className={"search-item"}>
                                                    <div className={"search-result-box-title"}> نتایج مربوط به معرفی اساتید و آموزشگاه :</div>
                                                    {
                                                        searchData && searchData.result && searchData.result.introduction.map((item) => {
                                                            return (
                                                                <div onClick={() => {
                                                                    history.push(`/introduction/${item._id}`, {props: item});
                                                                    searchToggleSearch(false)
                                                                }} className={"search-item-result"}>
                                                                    <span>{item.title}</span>
                                                                    <div dangerouslySetInnerHTML={{__html:item.description.substr(0,200)}}/>
                                                                </div>
                                                            )
                                                        })
                                                    }
                                                </div>
                                            }

                                        </>

                                        :
                                        <div>
                                            {"نتیجه ای یافت نشد"}
                                        </div>
                                }
                            </div>
                        }
                    </div>

                </div>
            </div>
        </div>
    );
};

export default Header;
